import { loadStylesheet } from 'components/storefront/editor/easyblocks-page/parser/utils';
import { isLayoutSectionAsset } from './utils';

/** @typedef {import('components/storefront/editor/easyblocks-page/asset-loader').default} AssetLoader */

/**
 * @param {AssetLoader} assetLoader
 */
function processStylesheet(assetLoader) {
  return {
    shouldProcessNode(node) {
      return node.name === 'link' && !isLayoutSectionAsset(node);
    },
    processNode(node) {
      const { href } = node.attribs;

      const loader = loadStylesheet(href);

      if (loader) {
        assetLoader.addLayoutAsset(loader);
      }

      return null;
    },
  };
}

export default processStylesheet;
